export const outboundOrderResources = {
  fr: {
    title: "Ordres de sortie", lifecycleAria: "État des ordres de sortie",
    tabs: { open: "En cours", finished: "Terminés" },
    search: { placeholder: "Ordre, référence, client, destination, article ou statut" },
    errors: { load: "Impossible de charger les ordres de sortie.", portalLoad: "Impossible de charger vos demandes de sortie.", action: "Action impossible.", create: "Création impossible.", lineMissing: "Ligne introuvable." },
    empty: { filtered: "Aucun ordre de sortie ne correspond à « {{search}} ».", view: "Aucun ordre de sortie dans cette vue.", portal: "Vous n’avez encore aucune demande de sortie." },
    portal: {
      title: "Portail client", overview: "Vue d’ensemble", newRequest: "Nouvelle demande",
      aria: "Fonctions du portail client", requests: "Demandes de sortie", simulator: "Simulateur ASN",
      cockpit: {
        appBarTitle: "Cockpit client", title: "Bonjour, {{name}}", customerFallback: "client", loading: "Chargement du cockpit…",
        subtitle: "Voici les opérations qui nécessitent votre attention.",
        loadError: "Certaines informations du cockpit n’ont pas pu être chargées.",
        priorityTitle: "Mes actions prioritaires", showAll: "Voir toutes", details: "Détails",
        noAction: "Aucune décision n’attend votre intervention.",
        flowTitle: "Suivi des demandes", recentTitle: "Activité récente",
        metrics: {
          actions: "Actions requises", actionsDetail: "{{count}} décision(s) à rendre",
          requests: "Demandes en cours", requestsDetail: "Demandes non terminées",
          deliveries: "Exécutions en cours", deliveriesDetail: "Préparation ou livraison engagée",
          alerts: "Alertes et exceptions", alertsDetail: "Stock insuffisant ou jalon en erreur"
        },
        flow: { submitted: "Soumises", available: "Stock contrôlé", allocated: "Allouées", delivery: "En exécution" }
      }
    },
    status: { SUBMITTED: "Soumis", ATP_AVAILABLE: "ATP disponible", ATP_FAILED: "Stock insuffisant", PARTIALLY_ALLOCATED: "Partiellement alloué", ALLOCATED: "Alloué", CANCELLED: "Annulé", delivered: "Livré", deliveryProgress: "Livraison en cours", prepared: "Préparé", toPrepare: "À préparer", preparationProgress: "Préparation en cours" },
    simulator: {
      info: "Cet outil génère uniquement des données de test. Chaque ASN est identifié comme une simulation et transmis au WMS au statut attendu.",
      customsToggle: "Dédouanement requis pour les prochains ASN simulés", generate: "Générer cet ASN test",
      generateError: "Impossible de générer cet ASN de simulation. Vérifiez que les données de démonstration nécessaires sont disponibles.",
      latest: "Dernières simulations", loadError: "Impossible de charger les simulations.", empty: "Aucun ASN de simulation généré.",
      created: "{{count}} ligne(s) · créé le {{date}}", test: "TEST", customs: "Dédouanement", customsRequired: "Dédouanement requis",
      scenarios: {
        STANDARD: { title: "ASN standard", description: "Une ligne article avec une quantité attendue de 10." },
        MULTI_LINE: { title: "ASN multi-lignes", description: "Trois articles avec des quantités attendues différentes." },
        LOT: { title: "Article géré par lot", description: "Une ligne avec un numéro de lot de simulation." },
        SERIALIZED: { title: "Article sérialisé", description: "Une ligne de trois unités attendues et sérialisées." },
        CUSTOMS: { title: "ASN avec dédouanement", description: "Une ASN standard avec l’indicateur Dédouanement positionné à Oui." }
      }
    },
    card: {
      fields: {
        order: "Ordre",
        destination: "Destination",
        client: "Client",
        warehouse: "Entrepôt",
        lines: "Nombre de ligne(s)",
        priority: "Priorité",
        reference: "Référence externe",
        submittedAt: "Date de soumission",
        status: "Statut",
        line: "Ligne",
        item: "Article",
        description: "Désignation",
        neededAt: "Date de besoin",
        requested: "Quantité demandée",
        atp: "Quantité disponible (ATP)",
        remaining: "Quantité restant à couvrir",
        expectedInbound: "Quantité attendue en entrée d’entrepôt",
        nextArrival: "Prochaine arrivée"
      },
      summary: "{{client}} · {{warehouse}} · {{count}} ligne(s) · priorité {{priority}}", noReference: "Sans référence externe", submittedAt: "soumis le {{date}}",
      accept: "Accepter et contrôler ATP", retryAtp: "Relancer le contrôle ATP", cancelReason: "Annulation demandée depuis le portail",
      collapse: "Réduire le détail", expand: "Afficher le détail", logistics: "Parcours logistique", tracking: "Suivi de l’ordre",
      destination: "Destination :", neededAt: "besoin le {{date}}", requested: "Demandé {{quantity}} {{uom}}", atp: "ATP {{quantity}} {{uom}}",
      remaining: "Reste à couvrir {{quantity}} {{uom}}", expectedInbound: "Entrées attendues entrepôt {{quantity}} {{uom}}", nextArrival: "prochaine arrivée {{date}}", confirmAllocation: "Confirmer l’allocation"
    },
    milestones: {
      labels: { SUBMITTED: "Ordre soumis", ATP: "Disponibilité contrôlée", ALLOCATED: "Stock alloué", PREPARATION: "Préparation", DELIVERY: "Livraison" },
      registered: "Demande enregistrée", stockUnavailable: "Stock insuffisant", checkRequired: "Contrôle à réaliser", stockAvailable: "Stock disponible",
      allocatedLines: "{{allocated}}/{{total}} ligne(s) allouée(s)", preparationCompleted: "Préparation terminée", pickingInProgress: "Prélèvement en cours",
      preparationPlanned: "Préparation planifiée", delivered: "Livré", deliveryInProgress: "Livraison en cours", missionPlanned: "Mission planifiée", upcoming: "À venir"
    },
    create: {
      title: "Nouvel ordre de sortie", warehouse: "Entrepôt source", requestType: "Type de demande", recipient: "Client destinataire", destination: "Destination finale",
      types: { POU_REQUEST: "Appel de stock POU", CUSTOMER_ORDER: "Ordre client", STOCK_TRANSFER: "Transfert de stock", EMERGENCY: "Demande urgente" },
      products: "Produits demandés ({{count}})", unit: "Unité {{uom}}", quantity: "Quantité", deleteLine: "Supprimer la ligne", item: "Article à ajouter", add: "Ajouter", reference: "Référence du donneur d’ordre", submit: "Soumettre l’ordre"
    }
  },
  en: {
    title: "Outbound orders", lifecycleAria: "Outbound order status",
    tabs: { open: "In progress", finished: "Completed" },
    search: { placeholder: "Order, reference, customer, destination, material or status" },
    errors: { load: "Unable to load outbound orders.", portalLoad: "Unable to load your outbound requests.", action: "Action failed.", create: "Unable to create the order.", lineMissing: "Line not found." },
    empty: { filtered: "No outbound order matches “{{search}}”.", view: "No outbound order in this view.", portal: "You do not have any outbound requests yet." },
    portal: {
      title: "Customer portal", overview: "Overview", newRequest: "New request",
      aria: "Customer portal features", requests: "Outbound requests", simulator: "ASN simulator",
      cockpit: {
        appBarTitle: "Customer Cockpit", title: "Hello, {{name}}", customerFallback: "customer", loading: "Loading cockpit…",
        subtitle: "Here are the operations requiring your attention.",
        loadError: "Some cockpit information could not be loaded.",
        priorityTitle: "My priority actions", showAll: "View all", details: "Details",
        noAction: "No decision is waiting for your input.",
        flowTitle: "Request tracking", recentTitle: "Recent activity",
        metrics: {
          actions: "Required actions", actionsDetail: "{{count}} decision(s) to make",
          requests: "Open requests", requestsDetail: "Requests not yet completed",
          deliveries: "Active executions", deliveriesDetail: "Picking or delivery underway",
          alerts: "Alerts and exceptions", alertsDetail: "Insufficient stock or failed milestone"
        },
        flow: { submitted: "Submitted", available: "Stock checked", allocated: "Allocated", delivery: "In execution" }
      }
    },
    status: { SUBMITTED: "Submitted", ATP_AVAILABLE: "ATP available", ATP_FAILED: "Insufficient stock", PARTIALLY_ALLOCATED: "Partially allocated", ALLOCATED: "Allocated", CANCELLED: "Cancelled", delivered: "Delivered", deliveryProgress: "Delivery in progress", prepared: "Prepared", toPrepare: "To prepare", preparationProgress: "Preparation in progress" },
    simulator: {
      info: "This tool generates test data only. Each ASN is identified as a simulation and sent to the WMS with the expected status.",
      customsToggle: "Customs clearance required for the next simulated ASNs", generate: "Generate this test ASN",
      generateError: "Unable to generate this simulated ASN. Check that the required demonstration data is available.",
      latest: "Latest simulations", loadError: "Unable to load simulations.", empty: "No simulated ASN has been generated.",
      created: "{{count}} line(s) · created on {{date}}", test: "TEST", customs: "Customs clearance", customsRequired: "Customs clearance required",
      scenarios: {
        STANDARD: { title: "Standard ASN", description: "One material line with an expected quantity of 10." },
        MULTI_LINE: { title: "Multi-line ASN", description: "Three materials with different expected quantities." },
        LOT: { title: "Lot-controlled material", description: "One line with a simulated lot number." },
        SERIALIZED: { title: "Serialized material", description: "One line with three expected serialized units." },
        CUSTOMS: { title: "ASN with customs clearance", description: "A standard ASN with the Customs clearance indicator set to Yes." }
      }
    },
    card: {
      fields: {
        order: "Order",
        destination: "Destination",
        client: "Customer",
        warehouse: "Warehouse",
        lines: "Number of line(s)",
        priority: "Priority",
        reference: "External reference",
        submittedAt: "Submission date",
        status: "Status",
        line: "Line",
        item: "Material",
        description: "Description",
        neededAt: "Required date",
        requested: "Requested quantity",
        atp: "Available quantity (ATP)",
        remaining: "Quantity still to cover",
        expectedInbound: "Expected warehouse receipt quantity",
        nextArrival: "Next arrival"
      },
      summary: "{{client}} · {{warehouse}} · {{count}} line(s) · priority {{priority}}", noReference: "No external reference", submittedAt: "submitted on {{date}}",
      accept: "Accept and check ATP", retryAtp: "Run ATP check again", cancelReason: "Cancellation requested from the portal",
      collapse: "Collapse details", expand: "Show details", logistics: "Logistics flow", tracking: "Order tracking",
      destination: "Destination:", neededAt: "required on {{date}}", requested: "Requested {{quantity}} {{uom}}", atp: "ATP {{quantity}} {{uom}}",
      remaining: "Remaining {{quantity}} {{uom}}", expectedInbound: "Expected warehouse receipts {{quantity}} {{uom}}", nextArrival: "next arrival {{date}}", confirmAllocation: "Confirm allocation"
    },
    milestones: {
      labels: { SUBMITTED: "Order submitted", ATP: "Availability checked", ALLOCATED: "Stock allocated", PREPARATION: "Preparation", DELIVERY: "Delivery" },
      registered: "Request recorded", stockUnavailable: "Insufficient stock", checkRequired: "Check required", stockAvailable: "Stock available",
      allocatedLines: "{{allocated}}/{{total}} line(s) allocated", preparationCompleted: "Preparation completed", pickingInProgress: "Picking in progress",
      preparationPlanned: "Preparation scheduled", delivered: "Delivered", deliveryInProgress: "Delivery in progress", missionPlanned: "Mission scheduled", upcoming: "Upcoming"
    },
    create: {
      title: "New outbound order", warehouse: "Source warehouse", requestType: "Request type", recipient: "Recipient customer", destination: "Final destination",
      types: { POU_REQUEST: "POU stock request", CUSTOMER_ORDER: "Customer order", STOCK_TRANSFER: "Stock transfer", EMERGENCY: "Urgent request" },
      products: "Requested materials ({{count}})", unit: "Unit {{uom}}", quantity: "Quantity", deleteLine: "Delete line", item: "Material to add", add: "Add", reference: "Ordering party reference", submit: "Submit order"
    }
  }
} as const;
